import {
  Component,
  computed,
  EventEmitter,
  inject,
  Input,
  Output,
  Signal,
  signal,
  WritableSignal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopupPosition } from '../../../directives/popup-position';
import { CloseOnOffClick } from '../../../directives/close-on-off-click';
import { ICorporatePaletteColor } from '@web/dtos';
import { TabsComponent } from '../../data-display/tabs/tabs';
import { ColorPickerComponent } from '../color-picker/color-picker.component';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { overlayPositions } from '../../../constants/overlayPositions';
import { CmsTextProviderService } from '../../../services/cms-text-provider.service';
import { CorporateDesignService } from '../../../services/corporate-design/corporate-design.service';

@Component({
  selector: 'aw-color-picker-list',
  standalone: true,
  imports: [CommonModule, PopupPosition, CloseOnOffClick, TabsComponent, ColorPickerComponent, OverlayModule],
  templateUrl: './color-picker-list.html',
})
export class ColorPickerListComponent {
  @Input() color: string = '';
  @Input() buttonSize: 'sm' | 'md' | 'lg'  = 'sm';
  @Output() colorChanged: EventEmitter<string> = new EventEmitter<string>();

  protected openState: WritableSignal<boolean> = signal(false);

  protected readonly overlayPositions: ConnectedPosition[] = overlayPositions as ConnectedPosition[];
  private readonly corporateDesignService: CorporateDesignService = inject(CorporateDesignService);
  protected readonly cmsTextProvider: CmsTextProviderService = inject(CmsTextProviderService);
  protected readonly colorOptions: ICorporatePaletteColor[] = this.corporateDesignService.corporateDesign().colorPalette;
  protected readonly isDarkMode: Signal<boolean> = computed((): boolean => {
    return this.corporateDesignService.isDarkModeActive();
  });


  pick(value: string): void {
    if(value.startsWith('#')){
      value = `#${value.replace(/^#/, '')}`
    }

    this.color = value;
    this.colorChanged.emit(value);
  }
  
  close(): void {
    this.openState.set(false);
  }

  getButtonSize(): string {
    switch (this.buttonSize) {
      case 'sm': 
        return 'size-5';
      case 'md': 
        return 'size-6.5';
      case 'lg': 
        return 'size-8';
    };
  }
}
